import React, { useEffect, useState } from "react";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Separator } from "./ui/separator";
import { CustomDatePicker } from "./custom-date-picker";
import { cn } from "@/lib/utils";
import { CustomModal } from "./custom-modal";
import { ChevronDown, FilterIcon } from "lucide-react";
import { formatType } from "@/lib/helper";

const Filter = ({
  selected,
  setSelected,
  refetch,
  selectDateFromChange,
  selectDateToChange,
}: any) => {
  const [dateFrom, setDateFrom] = React.useState<Date>();
  const [dateTo, setDateTo] = React.useState<Date>();
  const [mode, setMode] = useState('single')

  useEffect(() => {
    if (dateFrom !== undefined) {
      selectDateFromChange(formatType(dateFrom));
    }
    if (dateTo !== undefined) {
      selectDateToChange(formatType(dateTo));
    }
  }, [dateTo, dateFrom]);
  const getToday = () => {
    const currentDate = new Date();
    setDateFrom(currentDate);
    setDateTo(currentDate);
  };
  const get7days = () => {
    const currentDate = new Date();
    const prev = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
    setDateTo(currentDate);
    setDateFrom(prev);
  };
  const get1Month = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setMonth(prev.getMonth() - 1);
    setDateFrom(prev);
    setDateTo(currentDate);
  };
  const get6Month = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setMonth(prev.getMonth() - 6);
    setDateFrom(prev);
    setDateTo(currentDate);
  };
  const get1Year = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setFullYear(prev.getFullYear() - 1);
    setDateFrom(prev);
    setDateTo(currentDate);
  };
  return (
    <CustomModal
      button={
        <Button variant="outline" className="text-primary hover:text-primary">
          <FilterIcon />
          Sort by: {selected}
          <ChevronDown />
        </Button>
      }
    >
      <DialogHeader className="px-5 py-4 border-b-[1px] flex flex-row w-xs">
        <DialogTitle>Filter</DialogTitle>
      </DialogHeader>

      <div className="flex flex-col items-start gap-6 px-5 py-4">
        <div className="flex flex-col gap-2">
          <Label className="text-xs">Select Range</Label>
          <div className="flex flex-wrap gap-2">
            <Button
              type="button"
              // key={i}
              className={cn(
                "rounded-3xl text-xs h-6 p-[10px]",
                selected === "Today"
                  ? "bg-primary-0 hover:bg-primary-0 border-0"
                  : "bg-transparent hover:bg-transparent"
              )}
              variant="outline"
              onClick={() => {
                getToday();
                setSelected("Today");
                setMode('single')
                // selectDateFromChange("");
                // selectDateToChange("");
              }}
            >
              Today
            </Button>
            <Button
              type="button"
              className={cn(
                "rounded-3xl text-xs h-6 p-[10px]",
                selected === "7 days"
                  ? "bg-primary-0 hover:bg-primary-0 border-0"
                  : "bg-transparent hover:bg-transparent"
              )}
              variant="outline"
              onClick={() => {
                setSelected("7 days");
                get7days();
                setMode('single')
                // selectDateFromChange("");
                // selectDateToChange("");
              }}
            >
              7 days
            </Button>
            <Button
              type="button"
              className={cn(
                "rounded-3xl text-xs h-6 p-[10px]",
                selected === "1 month"
                  ? "bg-primary-0 hover:bg-primary-0 border-0"
                  : "bg-transparent hover:bg-transparent"
              )}
              variant="outline"
              onClick={() => {
                setSelected("1 month");
                get1Month();
                setMode('range')
                // selectDateFromChange("");
                // selectDateToChange("");
              }}
            >
              1 month
            </Button>
            <Button
              type="button"
              className={cn(
                "rounded-3xl text-xs h-6 p-[10px]",
                selected === "6 months"
                  ? "bg-primary-0 hover:bg-primary-0 border-0"
                  : "bg-transparent hover:bg-transparent"
              )}
              variant="outline"
              onClick={() => {
                setSelected("6 months");
                get6Month();
                setMode('range')
                // selectDateFromChange("");
                // selectDateToChange("");
              }}
            >
              6 months
            </Button>
            <Button
              type="button"
              className={cn(
                "rounded-3xl text-xs h-6 p-[10px]",
                selected === "1 year"
                  ? "bg-primary-0 hover:bg-primary-0 border-0"
                  : "bg-transparent hover:bg-transparent"
              )}
              variant="outline"
              onClick={() => {
                setSelected("1 year");
                get1Year();
                setMode('range')
                // selectDateFromChange("");
                // selectDateToChange("");
              }}
            >
              1 year
            </Button>
          </div>
        </div>

        <Separator orientation="horizontal" className="h-[1px] " />
        <div className="flex items-center gap-2 w-full ">
          <div className="flex flex-col gap-2 w-full">
            <Label htmlFor="link" className="text-xs">
              Start date
            </Label>
            <CustomDatePicker
              date={dateFrom}
              setDate={(e: any) => {
                selectDateFromChange(formatType(e));
                setDateFrom(e);
              }}

            />
          </div>
          <div className="flex items-center justify-center mt-6">
            <Separator orientation="horizontal" className="h-[1px] w-2" />
          </div>
          <div className="flex flex-col gap-2 w-full">
            <Label htmlFor="link" className="text-xs">
              End date
            </Label>
            <CustomDatePicker
              date={dateTo}
              setDate={(e: any) => {
                selectDateToChange(formatType(e));
                setDateTo(e);
              }}
            />
          </div>
        </div>
      </div>
      <DialogFooter className="px-5 py-3 border-t-[1px] flex flex-row sm:justify-between items-center">
        <DialogClose asChild>
          <Button
            type="button"
            className="bg-off-white text-primary0 h-8 rounded-[10px] p-[8px 12px] hover::bg-off-white"
            onClick={() => {
              selectDateToChange("");
              selectDateFromChange("");
              setDateTo(undefined);
              setDateFrom(undefined);
              setSelected("All times");
            }}
          >
            Reset
          </Button>
        </DialogClose>
        <DialogClose asChild>
          <Button
            type="button"
            className="bg-gradient-to-r from-primary to-primary-2 h-8 rounded-[10px] p-[8px 12px]"
            onClick={() => refetch()}
          >
            Apply
          </Button>
        </DialogClose>
      </DialogFooter>
    </CustomModal>
  );
};

export default Filter;
